import axios from "axios";
import { treesActions } from "../../../store/slices/trees";
import { warehouseActions } from "../../../store/slices/warehouse";
import { workerActions } from "../../../store/slices/workers";
import { buildTeamTree } from "./utils";
import getChannels from "./getChannels";

export const getTeamsId = "getTeams";
export const teamsDataId = "teamsList";

const getTeams = ({ M365server, cloner_key, controller }) => {
  const id = getTeamsId;

  return async (dispatch) => {
    dispatch(workerActions.start(id));
    try {
      const url = M365server + "mailapi/teams";
      const response = await axios.get(url, {
        signal: controller?.signal,
        headers: { cloner_key },
      });

      const teams = Array.isArray(response.data) ? response.data : [];
      dispatch(warehouseActions.load({ id: teamsDataId, data: teams }));

      // Pre-load each team's tree with the team root and an empty children
      // list so the drawer can render the team folder immediately while
      // channels are being fetched.
      for (const team of teams) {
        dispatch(
          treesActions.loadTree({
            id: `teams-${team.id}`,
            tree: buildTeamTree(team, []),
          })
        );
        dispatch(getChannels({ M365server, cloner_key, team }));
      }

      dispatch(workerActions.finish({ id }));
    } catch (e) {
      if (e.code === "ERR_CANCELED") {
        dispatch(workerActions.clear(id));
        return;
      }
      console.error(e);
      dispatch(workerActions.finish({ id, error: e.message }));
    }
  };
};

export default getTeams;
